// import Vue from 'vue';
import { createI18n } from 'vue-i18n';
import messages from './messages';

const i18n = createI18n({
    locale: window.locale, // set locale
    allowComposition: true, // because of legacy mode.
    messages, // set locale messages
    escapeParameter: true, // escape interpolated params (e.g. {query}) before they end up in messages rendered via v-html
    warnHtmlMessage: false, // some messages intentionally contain HTML and are rendered via v-html
});

export default i18n;
